import { h, Fragment } from 'preact'
import { useLayoutEffect } from 'preact/hooks'

export const Event = (props) => {
   useLayoutEffect(() => {
      // fermeture au click sur la X et depot de cookie
      let $closeBannerElement = document.getElementById('closeBannerEvent')
      if ($closeBannerElement !== null) {
         $closeBannerElement.addEventListener('click', () => {
            document.getElementById('zone_event').classList.add('isClosed')
            // Expire same day midnight
            var d = new Date()
            var expireDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59)
            document.cookie = 'HPcloseEvent=1;expires=' + expireDate.toUTCString() + ';'
         })
      }

      // cacher la bande si cookie présent
      if (document.cookie.search('HPcloseEvent') !== -1) {
         document.getElementById('zone_event').remove()
      }
   }, [])

   try {
      const { url, refZone, offerSpecificationCode, parentOfferSpecificationCode, advCanal, alt, images, adv_tracker } = props[0]

      let pdbIdc = offerSpecificationCode
      if (parentOfferSpecificationCode !== '') {
         pdbIdc += ',' + parentOfferSpecificationCode
      }

      return (
         <Fragment>
            <a
               href={url}
               class="d-block overflow-hidden"
               data-pdb-zid={refZone}
               data-pdb-sc="adv"
               data-pdb-idc={pdbIdc}
               data-pdb-vi={`${images.urlImageResize}${images.img112}`}
               data-pdb-ta={adv_tracker}
               data-adv-canal={advCanal}
               data-adv-cappingdata={`{'m': '${offerSpecificationCode}','p': '${parentOfferSpecificationCode}','t': '${adv_tracker}'}`}
               data-oevent-category="top_event"
               data-oevent-action={alt}
               data-oevent-label={url}
               data-oevent-other={`{"track_refZ":"${refZone}"}`}
            >
               <picture>
                  <source srcset={`${images.urlImageResize}${images.img112}?format=x304&saveas=webp`} media="(max-width: 1199px)" />
                  <img src={`${images.urlImageResize}${images.img112}?format=x380&saveas=webp`} alt={alt} />
               </picture>
            </a>
            <button
               type="button"
               id="closeBannerEvent"
               title="Fermer"
               class="closeBannerEvent"
               data-oevent-category="top_event-fermeture"
               data-oevent-action="fermer"
               data-oevent-label={alt}
               data-oevent-other={`{"track_refZ":"${refZone}"}`}
            >
               &times;
            </button>
         </Fragment>
      )
   } catch (error) {
      console.error('event.jsx', error)
   }
}
